import { createReducer } from '@reduxjs/toolkit'

import { adAccountProductsTableColumnsConfig } from 'configuration/tables/productTables'
import {
    CAMPAIGN_STATES,
    DATES,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
    PRODUCT_ASINS,
    PRODUCT_TITLES,
} from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [PRODUCT_ASINS]: [],
        [PRODUCT_TITLES]: [],
        [LABELS]: [],
        [FACT_TYPES]: [],
        [CAMPAIGN_STATES]: [],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [
            PRODUCT_ASINS,
            PRODUCT_TITLES,
            LABELS,
            FACT_TYPES,
            CAMPAIGN_STATES,
            METRIC_FILTERS,
        ],
        displayState: {},
    },
    table: getDefaultTable(
        serializeColumns(adAccountProductsTableColumnsConfig)
    ),
}

export default createReducer(initialState, () => {})
